export const EMPLOYEE_ZAZ_QUERY_KEY = 'employee-zaz';
export const ZAZ_SETTINGS_QUERY_KEY = 'zaz-settings';
